"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

export function CPHeaderNavigation() {
    const pathname = usePathname()

    const currentPage = (() => {
        if (pathname?.startsWith('/cp/account')) return 'account'
        if (pathname?.startsWith('/cp/promo')) return 'promo'
        if (pathname?.startsWith('/pricing')) return 'payments'
        if (pathname?.startsWith('/cp/processing') || pathname === '/cp') return 'processing'
        return null
    })()

    const getNavItemClass = (page: string) => {
        const baseClass = "onest-nav transition-all duration-300 px-3 py-2 rounded-md"
        return currentPage === page
            ? `${baseClass} text-black bg-gray-100 font-semibold`
            : `${baseClass} text-black hover:text-gray-900 hover:bg-gray-50`
    }

    return (
        <nav className="hidden lg:flex items-center gap-2">
            <Link
                href="/cp/processing"
                className={getNavItemClass('processing')}
            >
                Обработать
            </Link>
            <Link
                href="/pricing"
                className={getNavItemClass('payments')}
            >
                Пополнить баланс
            </Link>
            <Link
                href="/cp/promo"
                className={getNavItemClass('promo')}
            >
                Промокод
            </Link>
        </nav>
    )
}

